import { buildUrlUpdateCoworkerNoteApi } from 'routes/api';
import type { TypeCoworkerNoteRequest } from 'types/api';
import { NoScenario } from 'types/scenario';
import { useWriter } from '../useWriter';
import useData from '../useData';

export const useUpdateActionPlanCoworkerNote = () => {
    const { currentScenario, currentCountry, currentUnit, currentUnitType } = useData();

    const { writeData, ...response } = useWriter<TypeCoworkerNoteRequest, null>(
        {
            url: buildUrlUpdateCoworkerNoteApi(currentScenario?.id ?? NoScenario, currentCountry ?? '', currentUnit ?? '', currentUnitType ?? ''),
            method: 'PUT',
        }
    );

    return {
        ...response,
        updateActionPlanCoworkerNote: writeData
    };
};
